<app-tiles [userRole]="user.roleApp"></app-tiles>
<div fxLayout="row wrap">
    <div fxFlex="100" fxFlex.gt-sm="100" class="p-2"> 
        <app-latest-orders [userRole]="user.roleApp"></app-latest-orders>
    </div>
</div>  

<div fxLayout="row wrap" *ngIf="user.roleApp==='proprietaire'">
    <div fxFlex="100" fxFlex.gt-sm="70" class="p-2"> 
        <app-analytics></app-analytics>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="30" fxLayout="column">
        <div fxFlex="100" class="p-2">
            <mat-card>
                <div fxLayout="row" fxLayoutAlign="space-between center" class="text-muted">
                    <mat-icon class="mat-icon-xlg">monetization_on</mat-icon>
                    <div>
                        <h1>{{currency}} {{ (books$ | async)?.profit }}</h1>
                        <h2 class="fw-400">Mes Profits</h2>
                    </div>                
                </div>            
            </mat-card>
        </div>
        <div fxFlex="100" class="p-2">
            <mat-card>
                <div fxLayout="row" fxLayoutAlign="space-between center" class="text-muted">
                    <mat-icon class="mat-icon-xlg">monetization_on</mat-icon>
                    <div>
                        <h1>{{currency}} {{ (books$ | async)?.transfer }}</h1>
                        <h2 class="fw-400">Mes Virements</h2>
                    </div>                
                </div>            
            </mat-card>
        </div>       
        <div fxFlex="100" class="p-2">
            <mat-card>
                <div fxLayout="row" fxLayoutAlign="space-between center" class="text-muted">
                    <mat-icon class="mat-icon-xlg">monetization_on</mat-icon>
                    <div>
                        <h1>{{currency}} {{ (books$ | async)?.currentAmount }}</h1>
                        <h2 class="fw-400">Solde actuel</h2>
                    </div>                
                </div>            
            </mat-card>
        </div>
    </div>
</div>
<div fxLayout="row wrap" *ngIf="user.roleApp==='proprietaire'">
    <div fxFlex="100" fxFlex.gt-sm="100" class="p-2">
        <app-analytics-multi-years></app-analytics-multi-years>
    </div>
